import { Paper, IfRender } from 'library';
import { client, consoleLogInDev } from 'shared';
import React, { useEffect, useState } from 'react';
import { Provider } from 'models';
import { Grid } from '@material-ui/core';
import useSignUpAction from 'parent-portal/login/SignUpAction';
import { useCookies } from 'react-cookie';
import { useParams } from 'react-router-dom';
import { track } from 'shared';
import PublIcMessagingSuccessDialog from './PublIcMessagingSuccessDialog';
import { useHistory } from 'react-router-dom';
import { useUserContext } from 'UserContext';
import PublicMessageHeader from './PublicMessageHeader';
import Messages from './Messages';
import MessageForm from './MessageForm';
import AuthModal from 'parent-portal/login/AuthModal';

type ProfileParams = {
    id: string;
};

type Message = {
    body: string;
    status: 'awaiting' | 'failed' | 'sent';
};

export default function PublicMessaging({ provider }: { provider: Provider }) {
    const { id } = useParams<ProfileParams>();
    const [messages, setMessages] = useState<Message[]>([]);
    const [tempMessage, setTempMessage] = useState('');
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openAuth, setOpenAuth] = useState(false);
    const [cookies, setCookie] = useCookies(['provider_accessor']);
    const { SignUpWrapper, signUp } = useSignUpAction(() => handleChangeStatus('failed'));
    const { user } = useUserContext();
    const history = useHistory();

    function sendMessages() {
        messages.forEach((message) => {
            var body = {
                sender: user?.id,
                reciever: provider.user.id,
                message: message.body,
                message_type: 'PUBLIC_PROFILE',
                image: '',
            };

            client('api/messages/message-user/', { body })
                .then((response) => {
                    track('Public Messaging: Message sent', {
                        user_id: user?.id,
                    });
                })
                .catch((e) => {
                    consoleLogInDev(e);
                    track('Public Messaging: Error when sending message');
                });
        });
    }

    useEffect(() => {
        if (user && user?.signup_page == 4 && messages.length > 0) {
            sendMessages();
        }
    }, [user]);

    function onClose() {
        setOpenAuth(false);
        history.push('/home');
    }

    function handleChangeStatus(status: 'awaiting' | 'failed' | 'sent') {
        let newMessages = [...messages];

        newMessages.forEach((message) => {
            message.status = status;
        });

        setMessages(newMessages);
    }

    function addToMessages(body: string) {
        setMessages([{ body, status: 'awaiting' }, ...messages]);
    }

    function handleSend() {
        if (tempMessage.length > 0) {
            addToMessages(tempMessage);
            setTempMessage('');
            setCookie('provider_accessor', id, { path: '/' });
            track('External Public Profile: Public Messaging send button clicked');
            setOpenAuth(true);
        }
    }

    return (
        <Grid style={{ height: 300, paddingRight: 0, paddingLeft: 0, paddingBottom: 10 }}>
            <Grid container direction="column" justify="space-between" style={{ height: '100%', flexWrap: 'nowrap' }}>
                <PublicMessageHeader provider={provider} />
                <IfRender condition={messages.length > 0}>
                    <Messages messages={messages} signUp={signUp} />
                </IfRender>
                <MessageForm
                    provider={provider}
                    message={tempMessage}
                    setMessage={setTempMessage}
                    onClick={handleSend}
                />
            </Grid>
            <AuthModal open={openAuth} onClose={onClose} signup={true} modal={true} />
            <PublIcMessagingSuccessDialog open={openSuccess} onClose={onClose} provider={provider} />
        </Grid>
    );
}
